<template>
  <div class="baseFormBox">
    <div class="baseFormBox_label"><span class="require" v-if="options.require"
        :class="{requireMsg :options.value}">*</span>{{options.label}}</div>
    <div class="baseFormBox_data">
      <div class="city_base">
        <div class="city_noData">{{options.placeholder||'请选择'}}</div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script> 
import { mapGetters } from "vuex";
export default {
  data() {
    return { 
      form: {}, 
    };
  },
  props: ["index"],
  computed: {
    ...mapGetters(["formwork"]),
    options() {
      return this.formwork[this.index] ? this.formwork[this.index].options : { options: this.formwork.cityOptions };
    },
  },
};
</script> 
<style>
.baseFormBox_data .ant-cascader-picker {
  width: 100%;
}
.city_base {
  flex: 1;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  line-height: 36px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 4px;
  height: 36px;
  font-weight: 400;
  font-size: 14px;
  padding: 0 11px;
}
.city_noData {
  color: #c3c3c1;
}
</style>